<template>
  <div class="hello">

   <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      background="#ababab"
      img-width="1024"
      img-height="200"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <!-- Text slides with image -->

        <b-carousel-slide class="video-slide"
          img-src="../assets/img/slide-1.jpg"
          id="slide1"
        >
          <div class="slide-inner">
            <div class="embed-responsive">
            <youtube video-id="U7b6P86bNlI" :player-vars="playerVars" ref="youtube">
              <!-- <b-embed
                type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/embed/U7b6P86bNlI?&autoplay=1&&loop=1&playlist=U7b6P86bNlI"
                allowfullscreen
                allow="autoplay"
                autoplay="true"
              ></b-embed> -->
            </youtube>
            </div>
          </div>
        </b-carousel-slide>


<!--       <a v-b-modal.video-1>
        <b-carousel-slide
          img-src="../assets/img/slide-1.jpg"
        >
          <img src="../assets/img/play.svg" class="play" />
        </b-carousel-slide>
      </a> -->

      <!-- <b-carousel-slide
        img-src="../assets/img/slide-1.jpg"
      ></b-carousel-slide> -->
    </b-carousel>

    <b-modal id="video-1" centered hide-footer busy="true" modalClass="ww-video-modal">
      <template v-slot:default="">
        <b-container class="">
          <b-row>
            <b-col>
              <b-embed
                type="iframe"
                aspect="16by9"
                src="https://www.youtube.com/embed/uCVbjO8GvVY?&autoplay=1&rel=0"
                allowfullscreen
                allow="autoplay"
              ></b-embed>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>

    <b-container class="ww-section">
      <b-row>
        <b-col>
          <h1>A spa-worthy oasis designed for any space</h1>

          <p class="subhead">Investing in your bathroom is an investment in your space. Wetwall makes it easier than ever to have water-proof panels that are functionally beautiful, easy to install and offer a low cost of ownership.</p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="ww-section">
      <b-row>
        <b-col lg="5" >
          <b-img src="../assets/wetwall-image-1.jpg" fluid style="margin-bottom: 20px;"></b-img>
        </b-col>
        <b-col lg="7" style="text-align: left;">
          <p>Bathroom renovations continue to be one of the top improvements made in homes and commercial spaces. Renovation choices are often limited to beautiful, but expensive materials like marble, or lower-cost, unattractive solutions like metal shower units. Until now!</p>
          <p>Wetwall, a collection of 17 beautiful, water-proof panels are perfect for wet area applications and bring the look of luxury to any bathroom. Wetwall’s large format and on-trend designs are only surpassed in expectations by its 2.5 hour installation time, meaning you can quickly turn your bathroom dreams into a spa-worthy reality. </p>
          <p>Wetwall is easy to install over any substrate such as gypsum board, green board and fiberboard. It can even be installed over existing tile. Because it is a grout-free surface, it offers worry-free, easy maintenance. And its versatile design allows it to be used in a variety of places from shower walls and bath surrounds to accent walls and cladding.</p>
        </b-col>
      </b-row>
    </b-container>

    <!--
    <b-container class="ww-section feature-table">
      <b-row class="header">
        <b-col cols="6" md="4" class="copy"><p>S6dipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat.</p></b-col>
        <b-col cols="3" md="4" class="header"><span>Wetwall</span></b-col>
        <b-col cols="3" md="4" class="header"><span>Traditional Tile</span></b-col>
      </b-row>
      <b-row class="data shade">
        <b-col cols="6" md="4">lorum ipsum</b-col>
        <b-col cols="3" md="4"><img src="../assets/img/check.svg" class="check" /></b-col>
        <b-col cols="3" md="4"><img src="../assets/img/check.svg" class="check" /></b-col>
      </b-row>
      <b-row class="data">
        <b-col cols="6" md="4">lorum ipsum</b-col>
        <b-col cols="3" md="4"><img src="../assets/img/check.svg" class="check" /></b-col>
        <b-col cols="3" md="4"></b-col>
      </b-row>
      <b-row class="data shade">
        <b-col cols="6" md="4">lorum ipsum</b-col>
        <b-col cols="3" md="4"><img src="../assets/img/check.svg" class="check" /></b-col>
        <b-col cols="3" md="4"><img src="../assets/img/check.svg" class="check" /></b-col>
      </b-row>
      <b-row class="data">
        <b-col cols="6" md="4">lorum ipsum</b-col>
        <b-col cols="3" md="4"><img src="../assets/img/check.svg" class="check" /></b-col>
        <b-col cols="3" md="4"></b-col>
      </b-row>
      <b-row class="data shade">
        <b-col cols="6" md="4">lorum ipsum</b-col>
        <b-col cols="3" md="4"><img src="../assets/img/check.svg" class="check" /></b-col>
        <b-col cols="3" md="4"><img src="../assets/img/check.svg" class="check" /></b-col>
      </b-row>
      <b-row class="data">
        <b-col cols="6" md="4">lorum ipsum</b-col>
        <b-col cols="3" md="4"><img src="../assets/img/check.svg" class="check" /></b-col>
        <b-col cols="3" md="4"></b-col>
      </b-row>
    </b-container>
    -->

    <b-container class="ww-section">
      <b-row>
        <b-col lg="5" order="1" order-lg="2">
          <b-img src="../assets/wetwall-image-2.jpg" fluid style="margin-bottom: 20px;"></b-img>
        </b-col>
        <b-col lg="7" order="2" order-lg="1" class="icon-section">

          <b-row>
            <b-col>
              <div style="text-align: center;">
                <img src="../assets/img/waterproof-panel-logo.png" style="max-width: 320px;" />
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <p>Wetwall makes it easier than ever to provide water-proof panels that are functionally beautiful, easy to install and offer a low cost of ownership.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="icon">
              <img src="../assets/img/icons/icon-black-trend.png" />
            </b-col>
            <b-col class="text">
              <p>Trend-aware designs coordinate well with popular bath finishes and materials.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="icon">
              <img src="../assets/img/icons/icon-black-waterproof.png" />
            </b-col>
            <b-col class="text">
              <p>Patented, water-proof composite core withstands everyday use.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="icon">
              <img src="../assets/img/icons/icon-black-Tools.png" />
            </b-col>
            <b-col class="text">
              <p>Install a refreshed look in as little as 2.5 hours.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col class="icon">
              <img src="../assets/img/icons/icon-black-Wetwall.png" />
            </b-col>
            <b-col class="text">
              <p>Grout-free surface wipes clean with soap and a damp cloth for lasting beauty and easy maintenance.</p>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
                <div class="ww-button-block" style="margin-top: 20px; text-align: center;">
                  <a href="/gallery" >Get Inspired</a>
                  <a href="/designs" >View Designs</a>
                </div>
            </b-col>
          </b-row>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
export default {
  name: 'Home',
  props: {
    msg: String
  },

  data: function () {
    return {
      videoPlay1: false,
      playerVars: {
        loop: 1,
        playlist: 'U7b6P86bNlI',
      }
    }
  },

  methods: {

    swapSlide(slide) {
      this['videoPlay' + slide] = true;
      //jQuery('#slide1').hide();
    }

  },

  computed: {
    player() {
      return this.$refs.youtube.player
    }
  },

  /* eslint-disable */
  mounted () {
    this.player.mute();
    this.player.playVideo();
  }
  /* eslint-enable */

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.feature-table {
  border-top: 1px solid black;
  border-left: 1px solid black;
  border-bottom: 1px solid black;

  .header {
    .col-md-4 {
      border-right: 1px solid black;

      &.copy {
        padding-top: 80px;

        @media(max-width: 768px) {
          padding-top: 180px;
        }
      }

      &.header {
        padding-top: 40px;
        font-family: 'Montserrat', sans-serif;
        font-weight: 800;
        text-transform: uppercase;

        @media(max-width: 768px) {
          padding-top: 200px;
        }

        span {
          display: block;
          @media(max-width: 768px) {
            position: absolute;
            top: 50%;
            left: 50%;
            transform:  translateX(-50%) translateY(-50%) rotate(-90deg);
            transform-orign: top;
            width: 200px;
          }
        }
      }
    }
  }

  .data {
    .col-md-4 {
      padding: 20px;
      border-right: 1px solid black;

      &:first-child {
        font-family: 'Montserrat', sans-serif;
        text-align: left;
        text-transform: uppercase;
      }
    }

    .check {
      width: 30px;
      height: auto;
    }
  }

  .shade {
    background-color: #FAFAFA;
  }

}




h4 {
  margin: 40px 0 4px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
